export enum SortByType {
  flashDate = 'flashDate'
}

export enum OrderByType {
  ASC = 'ASC',
  DESC = 'DESC',
}